/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */
import * as References from './TemplateInstantiationService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#instantiateTemplate
 */
export const INSTANTIATE_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_automation_templatesrpc_TemplateInstantiationService_instantiateTemplate';
export const INSTANTIATE_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INSTANTIATE_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId', 'targetType', 'assetBindings'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.instantiateTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#getInstantiationStatus
 */
export const GET_INSTANTIATION_STATUS_QUERY_FIELD_NAME = 'com_hubspot_automation_templatesrpc_TemplateInstantiationService_getInstantiationStatus';
export const GET_INSTANTIATION_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTANTIATION_STATUS_QUERY_FIELD_NAME,
  args: ['taskId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getInstantiationStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#listInstantiationRequests
 */
export const LIST_INSTANTIATION_REQUESTS_QUERY_FIELD_NAME = 'com_hubspot_automation_templatesrpc_TemplateInstantiationService_listInstantiationRequests';
export const LIST_INSTANTIATION_REQUESTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_INSTANTIATION_REQUESTS_QUERY_FIELD_NAME,
  args: ['templateId', 'offset', 'filterByUserId', 'statusFilter', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.listInstantiationRequestsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#listWorkflowsForTemplate
 */
export const LIST_WORKFLOWS_FOR_TEMPLATE_QUERY_FIELD_NAME = 'com_hubspot_automation_templatesrpc_TemplateInstantiationService_listWorkflowsForTemplate';
export const LIST_WORKFLOWS_FOR_TEMPLATE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_WORKFLOWS_FOR_TEMPLATE_QUERY_FIELD_NAME,
  args: ['templateId', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.listWorkflowsForTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});